<template>
	<div class="w-full">
		<vs-row vs-justify="center">
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12" vs-sm="12" class="text-left">
				<vs-select autocomplete class="selectExample mt-5 w-full px-2" v-model="option"  :label="$t('MODULE.settingDomains')">
				    <vs-select-item :key="index" :value="item.value" :text="$t(`MODULE.${item.text}`)" v-for="(item, index) in opcionesDefault" />
				</vs-select>
			</vs-col>
		</vs-row>
		<h6 v-if="option !== 'allDomain'" class="vs-input--label mb-3 mt-5">
			<span v-if="inputType === 'email'">
				{{$t('MODULE.subtitleDomain')}}
			</span>
			<span v-else>
				{{$t('MODULE.matchList')}}
			</span>

		</h6>
		<Options class="mt-5" :index="index" v-if="option !== 'allDomain'"></Options>
	</div>

</template>
<script type="text/javascript">
	import Options from '../../componentsToQuestions/Options.vue';
	import { mapState } from 'vuex';
	export default {
		props: ['index'],
		components: { Options },
		data() {
			return {
				// option: 'allDomain',
				opcionesDefault: [
					{
						value: 'allDomain',
						text: 'acceptAllDomains'
					},
					{
						value: 'settingDomain',
						text:  'settingDomains'
					}
				]
			}
		},
		computed: {
			...mapState('resource',['questionsByPage']),
            /**
             * Obtiene el primer item del array
             */
			firstOption() {
				return this.questionsByPage[this.index].options[0];
			},
            /**
             * Obtiene el subtipo de pregunta
             */
			inputType() {
				return this.questionsByPage[this.index].inputType;
			},
            /**
             * Obtiene y configura los tipos de dominios que aceptara el email.
             */
			option: {
				get() {
					return this.firstOption === 'all'?'allDomain':'settingDomain';
				},
				set(value) {
					if(value === 'allDomain') return this.questionsByPage[this.index].options = ['all'];
					if(this.inputType === 'email') return this.questionsByPage[this.index].options = ['@domain.com'];
					return this.questionsByPage[this.index].options = ['opcion 1'];
				}
			}
		}

	}
</script>
